import { createVuetify } from "vuetify";
import * as baseComponents from "vuetify/components";
import * as directives from "vuetify/directives";

const components = {
  ...baseComponents,
};

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        colors: {
          // primary: "#1B84FF",
          // primary: "#AB47BC",
          primary: "#1976D2",
          background: "rgb(249, 249, 250)",
        },
      },
      dark: {
        colors: {
          // primary: "#1B84FF",
          // primary: "#AB47BC",
          // primary: "#BA68C8",
          primary: "#1976D2",
          background: "rgb(41, 42, 45)",
          surface: "rgb(33, 34, 37)",
          "surface-light": "rgb(25, 26, 30)",
          // error: "EF5350",
        },
      },
    },
  },
  defaults: {},
});

export default vuetify;
